export enum SmsVerificationEnum {
  CodeNotArrived = 'Kod nie dotarł?',
  ConfirmationSmsCode = 'Potwierdź',
  ConfirmationSmsText = 'W celu wystawienia wniosku wpisz kod SMS wysłany na numer:',
  ConfirmationSmsTitle = 'Potwierdzenie SMS',
  ErrorAttemptLimitReachedTitle = 'Przekroczono limit prób',
  ErrorCodeExpiredTitle = 'Kod wygasł',
  ErrorInvalidCodeErrorBody = 'Spróbuj wprowadzić kod ponownie.',
  ErrorInvalidCodeErrorTitle = 'Kod nieprawidłowy',
  ErrorInvalidPhoneNumberBody = 'Zweryfikuj numer telefonu.',
  ErrorInvalidPhoneNumberTitle = 'Nie udało się wysłać SMS',
  ErrorSentSmsLimitReachedTitle = 'Przekroczono limit wysłanych SMS',
  ErrorVerificationAlreadyPassedBody = 'Spróbuj ponownie.',
  ErrorVerificationAlreadyPassedTitle = 'Ups! Coś poszło nie tak.',
  ErrorVerificationNotInitiatedBody = 'Spróbuj ponownie.',
  ErrorVerificationNotInitiatedTitle = 'Ups! Coś poszło nie tak.',
  GenericErrorCheckCode = 'Nie udało się zweryfikować kodu.',
  GenericErrorSendSMS = 'Nie udało się wysłać SMS.',
  InvalidCode = 'Kod nieprawidłowy',
  PleaseWait = 'Prosimy o chwilę cierpliwości...',
  PreparingPayment = 'Przygotowanie płatności',
  ResendCode = 'Wyślij kod ponownie',
  SendCodeAgain = 'Wyślij jeszcze raz ',
  SmsMissingCodeError = 'Proszę wprowadzić kod SMS.',
  Step = 'KROK',
  SubmittingApplication = 'Wystawianie wniosku',
  SuccessSendSMS = 'Wysłano ponownie kod SMS.',
  TransmittingData = 'Przesyłanie Twoich danych',
  ValidationCode = 'Weryfikacja kodu SMS...',
}
